import { ObjectId } from 'bson';
import { GetterTree } from 'vuex';
import { RootState } from '../../state';
import userState from './state';

export const enum GetterTypes {
  getUser = 'getUser',
  getId = 'getId',
  getObjectId = 'getObjectId',
  getProgramDoc = 'getProgramDoc',
  isDialogOpen = 'isDialogOpen',
  isProfileComplete = 'isProfileComplete'
}
type UserGetterCtx<T> = (
  state: typeof userState,
  getters: any,
  rootState: RootState,
  rootGetters: any
) => T;
export interface UserGetters extends GetterTree<typeof userState, RootState> {
  getUser: UserGetterCtx<any | null>;
  getId: UserGetterCtx<string | null>;
  getObjectId: UserGetterCtx<ObjectId | null>;
  getProgramDoc: UserGetterCtx<any | null>;
  isDialogOpen: UserGetterCtx<boolean>;
  getUserType: UserGetterCtx<string | null>;
  isProfileComplete: UserGetterCtx<boolean>;
}
export const getters: UserGetters = {
  getUser: state => {
    return state.user;
  },
  getId: state => {
    const user = state.user as any;
    if (user) return user._id;
    return null;
  },
  getObjectId: state => {
    const user = state.user as any;
    let idStr = user?._id;
    if (!idStr && typeof user?.userId === 'string') {
      idStr = user.userId;
    }
    // Only construct BSON ObjectId if the string is a valid 24-char hex.
    if (typeof idStr === 'string' && /^[a-f\d]{24}$/i.test(idStr)) {
      try {
        return new ObjectId(idStr);
      } catch (_e) {
        // fall-through to return null
      }
    }
    return null;
  },
  isDialogOpen: state => {
    return state.isOpenDialog;
  },
  getProgramDoc: state => {
    return state.programDoc;
  },
  getUserType: state => {
    return state.userType;
  },
  isProfileComplete: state => {
    return state.profileComplete === true;
  }
};
